import {http} from './http_service';

export function getVesselByUserId(id) {
    return http().post('/vessels/get-vessels-by-user-id', id);
}